"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-default-export */
/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_i18next_1 = require("react-i18next");
const button_1 = require("../../components/ui/button");
const open_link_svg_1 = __importDefault(require("../../assets/open-link.svg"));
const tonconnect_module_css_1 = __importDefault(require("./tonconnect.module.css"));
const TonConnectPage = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const TgObj = sdk_1.default;
    function replaceSpecialChars(input) {
        // Заменяем символ % на --AA--
        let result = input.replace(/%/g, '--PERCENT--');
        // Заменяем точку . на --BB--
        result = result.replace(/\./g, '--DOTSCH--');
        return result;
    }
    const [customSearch, setCustomSearch] = (0, react_1.useState)('');
    const urlSearch = (0, react_1.useMemo)(() => new URLSearchParams(location.search), [location.search]);
    (0, react_1.useEffect)(() => {
        try {
            const id = urlSearch.get('id');
            const v = urlSearch.get('v');
            const r = urlSearch.get('r');
            const ret = urlSearch.get('ret');
            console.log('urlSearch.get r', r);
            if (id && v && r) {
                const compressedJson = encodeURIComponent(JSON.stringify(r));
                const cleanRequest = replaceSpecialChars(compressedJson);
                console.log('compressedJson', compressedJson);
                console.log('cleanRequest', cleanRequest);
                setCustomSearch(`tonconnect-v__${v}-id__${id}-r__${cleanRequest}-${ret ? 'ret__' + ret : ''}`);
            }
        }
        catch (err) {
            console.log(err);
        }
    }, [urlSearch]);
    const openTgLink = () => {
        window.open(`https://t.me/delabtonbot/wallet?startapp=${customSearch}`, '_blank');
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: tonconnect_module_css_1.default.container, children: [(0, jsx_runtime_1.jsxs)("div", { className: tonconnect_module_css_1.default.content, children: [(0, jsx_runtime_1.jsx)("img", { src: open_link_svg_1.default, alt: "img" }), (0, jsx_runtime_1.jsx)("p", { className: tonconnect_module_css_1.default.description, children: t('common.tonconnect-descr') })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { className: tonconnect_module_css_1.default.btn, onClick: () => openTgLink(), children: t('common.open-in-twa') })] }));
};
exports.default = TonConnectPage;
